<template>
  <div>

    <b-row class="mt-1 mb-4">
      <b-col>
        <b-button class="pull-right" variant="primary" v-b-modal.create_or_update_kpi>KPI aanmaken</b-button>
      </b-col>
    </b-row>

    <table class="table table-hover">
      <thead>
      <tr>
        <th>Icoon</th>
        <th>Label</th>
        <th>Waarde</th>
        <th>&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="kpi in kpis">
        <td>{{kpi.icon.text}}</td>
        <td>{{kpi.label}}</td>
        <td>{{kpi.value}}</td>
        <td>
          <b-btn size="sm" variant="secondary" class="mr-2" @click="openCreateOrUpdateKpiModal(kpi)">Bewerk</b-btn>
          <b-btn size="sm" variant="danger" @click="openDestroyKpiModal(kpi)">Verwijderen</b-btn>
        </td>
      </tr>
      </tbody>
    </table>

    <b-modal id="create_or_update_kpi" title="KPI aanmaken" hide-footer>
      <b-form @submit.prevent="createOrUpdateKpi">
<!--        <b-form-group label="Icoon">-->
<!--          <b-form-select :options="iconOptions" required v-model="kpi.icon"></b-form-select>-->
<!--        </b-form-group>-->

        <b-form-group label="Icoon">
          <v-select :options="iconOptions" label="text" v-model="kpi.icon" class="mb-3">
            <template v-slot:option="option">
              <img :src="getIconUrl(option)" :alt="option.text" class="img-thumbnail" style="max-width: 40px;" v-if="option.value">
              {{ option.text }}
            </template>
          </v-select>
        </b-form-group>

        <b-form-group label="Label">
          <b-form-input type="text" required v-model="kpi.label"></b-form-input>
        </b-form-group>
        <b-form-group label="Waarde">
          <b-form-input type="text" required v-model="kpi.value"></b-form-input>
        </b-form-group>
        <hr>
        <b-button class="pull-left" variant="danger" @click="closeCreateOrUpdateKpiModal" :disabled="loading">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success" :disabled="loading">Opslaan</b-button>
      </b-form>
    </b-modal>

    <b-modal id="destroy_kpi" ref="destroy_update" title="KPI verwijderen">
      <p class="my-4">
        Weet je zeker dat je de KPI <strong v-if="kpi_to_delete">"{{ kpi_to_delete.label }}"</strong> wilt verwijderen? Deze actie is onomkeerbaar.
      </p>
      <template v-slot:modal-footer>
        <b-button @click="closeDestroyKpiModal" :disabled="loading">Nee</b-button>
        <b-button variant="danger" @click="destroyKpi" :disabled="loading">Ja, verwijder</b-button>
      </template>
    </b-modal>

  </div>
</template>
<script>
import {addData, updateData, deleteItem} from "@/api";

export default {
  name: 'project-update-kpis',

  props: [
    'kpis'
  ],

  data() {
    return {
      kpi: {
        id: null,
        icon: null,
        label: null,
        value: null,
      },
      kpi_to_edit: null,
      kpi_to_delete: null,
      loading: false,
      iconOptions: [
        { value: '1', text: 'Rendement (ROI per jaar)'},
        { value: '2', text: 'Totaal geïnvesteerd / totaal vermogen'},
        { value: '3', text: 'Prognose rendement (ROI per jaar)'},
        { value: '4', text: 'Prognose totaalrendement'},
        { value: '5', text: 'Totaalrendement'},
        { value: '6a', text: 'Geïnvesteerd vermogen - EU'},
        { value: '6b', text: 'Geïnvesteerd vermogen - USD'},
        { value: '7a', text: 'Totaal uitgekeerd - EU'},
        { value: '7b', text: 'Totaal uitgekeerd - USD'},
        { value: '8a', text: 'Periodieke uitkering - EU'},
        { value: '8b', text: 'Periodieke uitkering - USD'},
        { value: '19a', text: 'Totaal vermogen - EU'},
        { value: '19b', text: 'Totaal vermogen - USD'},
        { value: '9', text: 'Vermogensgroei'},
        { value: '10', text: 'Mijn deelname'},
        { value: '11', text: 'Projecten lopend'},
        { value: '12', text: 'Projecten afgerond'},
        { value: '13', text: 'Startdatum'},
        { value: '14', text: 'Prognose einddatum / einddatum'},
        { value: '15', text: 'Planning'},
        { value: '16', text: 'Voorverhuur (%)'},
        { value: '17a', text: 'Voorverhuur - EU'},
        { value: '17b', text: 'Voorverhuur - USD'},
        { value: '18a', text: 'Exploitatie - EU'},
        { value: '18b', text: 'Exploitatie - USD'},
        { value: '20', text: 'Bezetting / lokale partner'},
        { value: '21', text: 'Renovatie'},
        { value: '22', text: 'Bouw'},
      ]
  }
  },

  methods: {
    async createOrUpdateKpi() {
      this.loading = true;

      if (this.kpi_to_edit) {
        await updateData(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}/kpis/${this.kpi_to_edit.id}`, {
          icon: this.kpi.icon.value,
          label: this.kpi.label,
          value: this.kpi.value,
        }).then(response => {
          this.$emit('changedKpis', response.data.data);

          this.loading = false;
          this.closeCreateOrUpdateKpiModal();
        });
      } else {
        await addData(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}/kpis`, {
          icon: this.kpi.icon.value,
          label: this.kpi.label,
          value: this.kpi.value,
        }).then(response => {
          this.$emit('changedKpis', response.data.data);

          this.loading = false;
          this.closeCreateOrUpdateKpiModal();
        });
      }
    },

    async destroyKpi() {
      await deleteItem(`projects/${this.$route.params.id}/updates/${this.$route.params.update_id}/kpis/${this.kpi_to_delete.id}`).then(response => {
        this.$emit('changedKpis', response.data.data);

        this.loading = false;
        this.closeDestroyKpiModal();
      });
    },


    openCreateOrUpdateKpiModal(kpi){
      if (kpi) {
        this.kpi_to_edit = kpi;
        this.kpi = {...kpi};
      }

      this.$bvModal.show('create_or_update_kpi')
    },

    closeCreateOrUpdateKpiModal() {
      this.$bvModal.hide('create_or_update_kpi');

      this.kpi_to_edit = null;

      this.kpi = {
        icon: null,
        label: null,
        value: null,
      };
    },

    openDestroyKpiModal(kpi) {
      this.kpi_to_delete = kpi;
      this.$bvModal.show('destroy_kpi');
    },

    closeDestroyKpiModal() {
      this.$bvModal.hide('destroy_kpi');
    },

    getIconUrl(icon) {
      if (icon.value.indexOf('a') > 0) {
        return `${process.env.VUE_APP_API_URL}/img/kpi/EUR/${icon.value.replace('a', '')}.svg`;
      }

      if (icon.value.indexOf('b') > 0) {
        return `${process.env.VUE_APP_API_URL}/img/kpi/USD/${icon.value.replace('b', '')}.svg`;
      }

      return `${process.env.VUE_APP_API_URL}/img/kpi/EUR/${icon.value}.svg`;
    }
  }
}
</script>
